import moment from 'moment'
import 'moment-timezone'
import { formatHelper } from './format'

export const dateHelper = {
  getWeekCalendar,
  setDefaultTimeZone,
  isSameMonth,
  isSameDay,
  checkSameDay,
  secondsToHMS,
}

function setDefaultTimeZone(timeZone) {
  if (timeZone) {
    moment.tz.setDefault(timeZone)
  }
}

function isSameDay(timestamp) {
  return moment(formatHelper.formatDateTime(timestamp, 'YYYY-MM-DD')).isSame(
    moment().format('YYYY-MM-DD'),
    'day'
  )
}

function isSameMonth(timestamp) {
  return moment(formatHelper.formatDateTime(timestamp, 'YYYY-MM-DD')).isSame(
    moment().format('YYYY-MM-DD'),
    'month'
  )
}

function getWeekCalendar(weeks = 2, showPast = false) {
  const days = []
  for (let i = 0; i < 7 * weeks; i++) {
    const today = moment()
    today.add(i, 'days')
    days.push({
      number: parseInt(today.format('DD')),
      text: today.format('dddd').substring(0, 1),
      timestamp: today.unix(),
    })
  }
  if (showPast) {
    for (let i = 1; i <= 7; i++) {
      const today = moment()
      today.subtract(i, 'days')
      days.unshift({
        number: parseInt(today.format('DD')),
        text: today.format('dddd').substring(0, 1),
        timestamp: today.unix(),
      })
    }
  }
  return days
}

function checkSameDay(timestamp1, timestamp2) {
  return moment(formatHelper.formatDateTime(timestamp1, 'YYYY-MM-DD')).isSame(
    moment(formatHelper.formatDateTime(timestamp2, 'YYYY-MM-DD')),
    'day'
  )
}

function secondsToHMS(inputSeconds) {
  const totalSeconds = Math.floor(inputSeconds)

  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  const parts = []

  if (hours > 0) parts.push(`${hours}h`)
  if (minutes > 0) parts.push(`${minutes}m`)
  if (seconds >= 0) parts.push(`${seconds}s`)

  return parts.join(' ')
}
